<template>
  <div>
    <div class="page-title">Careers with {{siteName}}</div>

    <section>
      <p>Working in Scholarly Publishing is.. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisiLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.</p>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi.</p>
    </section>

    <title-block title="Open Positions" link-title="View All" link-name="" color-theme="primary-color">
      <div class="position-item" v-for="item in positions">
        <div class="posted-date">Posted {{getFormatedDate(item.postedDate)}}</div>
        <div class="title"><span v-if="item.titlePrefix">{{item.titlePrefix}}: </span>{{item.title}}</div>
        <div class="description">{{item.description}}</div>
        <div class="" v-if="item.url"><a :href="item.url">View and Apply for this Position ></a></div>
      </div>
    </title-block>

  </div>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'careers',
    mixins: [ UtilityMixin ],
    components: {
      TitleBlock
    },
    data () {
      return {
        siteName: process.env.SITE_NAME,
        positions: [
          {
            postedDate: new Date(Date.now()),
            title: 'Junior Editor',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
            url: 'http://www.grc.org/programs.aspx?id=16786'
          },
          {
            postedDate: new Date('2016-02-09'),
            title: 'Junior Editor',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
            url: 'http://www.grc.org/programs.aspx?id=16786'
          },
          {
            postedDate: new Date('2015-02-09'),
            title: 'Junior Editor',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi',
            url: 'http://www.grc.org/programs.aspx?id=16786'
          }
        ]
      }
    }
  }
</script>


<style lang="scss" scoped>
  section {
    margin-top: $spacing-extra-large;
  }
  .position-item {
    padding-bottom: $spacing-large;
    margin-bottom: $spacing-large;
    border-bottom: 1px solid $devider;
    margin-top: $spacing-large;
  .posted-date {
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-style: italic;
    line-height: 1.42;
    text-align: left;
    color: $black;
    opacity: 0.6;
    margin-bottom: 7.5px;
  }
  .title {
    font-family: 'Merriweather';
    font-style: italic;
    color: $primary-color;
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 7.5px;
    text-decoration: underline;
  }
  .description {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 1.38;
    text-align: justify;
    color: $accent-color-3;
  }
  }
</style>



// WEBPACK FOOTER //
// CareersPage.vue?3cccad39